module.exports = __webpack_public_path__ + "static/img/map.3c75810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map.png
// module id = EoJS
// module chunks = 16